module.exports = __webpack_public_path__ + "img/cool-four.57dcb5dc.svg";